module.exports = __webpack_public_path__ + "media/images/sports_coaching/stella@3x-e1576465f8adab40ce18056c3a6b6de6.jpg";